import React, {Component} from "react";

class QuickLinks extends Component {
    render(){
        return(
            <div>
                <h1>{this.props.title}</h1>
                <div>
                    {this.props.links.map((links, index)=>
                        <a key={index} href={links.href}>{links.label}</a>
                    )}
                </div>
            </div>
        )
    }
}

export default QuickLinks;